import React, { useCallback, useRef, useState } from 'react';
import ConfirmDialog from '../components/common/ConfirmDialog';

/**
 * Konfirmim si premtim — `if (!await confirm({...})) return;`
 *
 * `window.confirm` duket e lehtë pikërisht sepse është një rresht. Kostoja e
 * saj është diku tjetër: bllokon fillin e UI-së, del me kokën
 * "localhost:3000 says", nuk e ndjek temën, dhe — më keq — nuk tregon dot
 * ÇFARË po preket. "A jeni i sigurt që doni ta fshini këtë klient?" është e
 * njëjta fjali për të gjithë klientët, ndaj një klikim te rreshti i gabuar
 * konfirmohet njësoj lehtë si ai i saktë.
 *
 * `ConfirmDialog` e zgjidh atë, por kërkon një gjendje dhe një element për çdo
 * vend ku përdoret — dhjetë rreshta aty ku më parë kishte një. Ky grep e mban
 * formën e `window.confirm` dhe pamjen e dialogut:
 *
 *   const [confirm, confirmUI] = useConfirm();
 *   …
 *   if (!await confirm({ message: 'Fshi këtë klient?', details: c.name })) return;
 *   …
 *   {confirmUI}
 *
 * `busy` mbahet nga thirrësi kur veprimi zgjat; pa të, dialogu mbyllet menjëherë
 * dhe një klikim i dyfishtë e dërgon kërkesën dy herë.
 */
export default function useConfirm() {
  const [state, setState] = useState(null);
  const resolveRef = useRef(null);

  const confirm = useCallback((opts = {}) => new Promise((resolve) => {
    resolveRef.current = resolve;
    setState({ title: 'Konfirmo veprimin', confirmLabel: 'Vazhdo', color: 'error', ...opts });
  }), []);

  const settle = useCallback((answer) => {
    setState(null);
    // Premtimi zgjidhet GJITHNJË — edhe në "Anulo", edhe në mbyllje me Esc.
    // Po të zgjidhej vetëm te "po", çdo anulim do të linte një `await` të varur
    // përgjithmonë, dhe me të gjithë kodin që vjen pas tij.
    const r = resolveRef.current;
    resolveRef.current = null;
    if (r) r(answer);
  }, []);

  const element = (
    <ConfirmDialog
      open={Boolean(state)}
      title={state?.title || ''}
      message={state?.message || ''}
      details={state?.details || null}
      confirmLabel={state?.confirmLabel}
      cancelLabel={state?.cancelLabel}
      color={state?.color}
      busy={Boolean(state?.busy)}
      onConfirm={() => settle(true)}
      onClose={() => settle(false)}
    />
  );

  return [confirm, element];
}
